import React, { useState, useEffect } from 'react';
import Menu from './Menu/Menu';
import Fees from './Fees/fees';
import AppointmentList from './Appointments/AppointmentList/AppointmentList.container';
import ContractTemplates from '../Markers/Views/ContractTemplates/ContractTemplates.view';

const GenericContractManagement = ({ grouping }) => {
	document.title = `Contract Management - ${grouping}s Menu`
    const [activeScreen, setActiveScreen] = useState('');

    useEffect(() => {
        setActiveScreen('');
    }, [grouping]);

	const handleActiveModal = (menuName = '') => {
		setActiveScreen(menuName);
	}

	switch (activeScreen) {
		case 'templates':
			return <ContractTemplates handleActiveModal={handleActiveModal} appointeeType={grouping} />;
		case 'appointments':
			return <AppointmentList handleActiveModal={handleActiveModal} grouping={grouping} />;
		case 'fees':
			return <Fees handleActiveModal={handleActiveModal} grouping={grouping} />;
		default:
			return (
				<Menu title={`${grouping}s`} onChange={handleActiveModal} />
			);
	}
};

export default GenericContractManagement;
